app.controller("QuestionnaireVersionsController", ["$scope", "$stateParams", "QuestionnairesService", "StaticData", "$uibModal", "$state", "ConfirmModal", "toastr", "usSpinnerService",
    function ($scope, $stateParams, QuestionnairesService, StaticData, $uibModal, $state, ConfirmModal, toastr, usSpinnerService) {
        $scope.format = 'dd-MM-yyyy HH:mm';
        $scope.questionnaires = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 10;
        $scope.title = $stateParams.title;
        $scope.template = $stateParams.template;
        $scope.owned = $stateParams.owned === 'true';

        loadPage($stateParams.page, $scope.query, $scope.fromDate, $scope.toDate, function () {
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, query, fromDate, toDate, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            $scope.currentPage = $stateParams.page;
            QuestionnairesService.getVersions($stateParams.template).then(function (result) {
                $scope.questionnaires = result;
                $scope.totalItems = result.length;
                usSpinnerService.stop("root");
                cb();
            }, function (err) {
                console.log('--err--', err);
            });
        }

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                fromDate: $scope.fromDate ? $scope.fromDate.getTime() : undefined,
                toDate: $scope.toDate ? $scope.toDate.getTime() : undefined,
                type: $scope.filterType
            });
        };

        $scope.sendHistory = function (questionnaire) {
            $state.go("admin.questionnaires.history", { 'template': questionnaire._id, 'title': questionnaire.title });
        }
    }
]);
